import { customerInTrialOrTrialEnded } from 'src/data/customer';
import { FEATURE_LIMITS } from 'src/data/featureLimits';

import { useCurrentCustomer } from './useCurrentCustomer';
import { useCustomFeatureLimitsData } from './useCustomFeatureLimitsData';

/**
 * Whether the customer has exhausted the performance-predictions limit.
 * The shared gate for every "hide scores behind the locked Get score state" treatment.
 * The locked treatment is a free-trial experience only: paying customers with a finite
 * prediction limit (basic plan) keep their pre-trial-revamp scoring UI.
 */
export const useAtPerformancePredictionsLimit = () => {
  const currentCustomer = useCurrentCustomer();
  const limitsData = useCustomFeatureLimitsData(FEATURE_LIMITS.performancePredictions);

  if (!customerInTrialOrTrialEnded(currentCustomer)) {
    return false;
  }

  return limitsData?.limit != null && limitsData.currentCount >= limitsData.limit;
};
